export const IUL10Pay = {
    "id": "8ca33bfd-8192-41c6-a62c-7c964e58cc99",
    "webhook": "https://api.myilia.com/estimation/web-hook/39dd13e9-2750-4baf-a07b-db7f8cda3123",
    "run": {
        "estimatortype": "IUL",
        "iulsolvefor": "Death_Benefit",
        "stress": false,
        "illustration": true,
        "comparison": false,
        "reports": false,
        "deathbenefitonly": false,
        "express": false
    },
    "common": {
        "premiumterm": 10,
        "contributionterm": 7,
        "monthlypayclientextra": 0.05,
        "paymentfrequency": "Annual",
        "productcode": "941",
        "fullname": "Yogesh Patel",
        "verbose": false,
        "agent": {
            "fullname": "Ben Grams",
            "phoneareacode": "800",
            "phonedialnumber": "2949940",
            "addressline1": "5830 Granite Pkwy",
            "addressline2": "Suite 700",
            "addresscity": "Plano",
            "addressstate": "TX",
            "zip": "75024"
        },
        "incomeagefrom": 65,
        "incomeageto": 90,
        "trustfee": 1350,
        "pensionunderwriting": "Multi-Life",
        "issueage": "50",
        "premium": 13980,
        "gender": "Male",
        "rateclass": "Standard_NT",
        "dateofbirth": "02/11/1977",
        "funddateilia": "07/13/2022",
        "tranchenumber": "47",
        "carrier": "ALZ",
        "blendpercentage": [
            {
                "agefrom": 10,
                "ageto": 29,
                "blend": 0
            },
            {
                "agefrom": 30,
                "ageto": 39,
                "blend": 0.3
            },
            {
                "agefrom": 40,
                "ageto": 49,
                "blend": 0.35
            },
            {
                "agefrom": 50,
                "ageto": 54,
                "blend": 0.4
            },
            {
                "agefrom": 55,
                "ageto": 100,
                "blend": 0.5
            }
        ],
        "illustrationissuestate": "NV",
        "contributionamount": 50000,
        "totaldeathbenefit": "325000",
        "distributionloanrate": 6.15,
        "reportsalessummaryage": 90,
        "reportlowpointduration": 18,
        "growthrate": 0.0665,
        "incometaxrate": 0.37,
        "capitalgainstaxrate": 0.2,
        "statetaxrate": 0.055,
        "afrrate": 0.0454,
        "managementfee": 0.005,
        "arrangementfee": 500,
        "contributionamountemployer": 0,
        "paymentfrequencyemployer": "Annual"
    },
    "illustration": {
        "mecavoidance": "Adjust_Premiums",
        "deathbenefittype": "Specify_Amount",
        "deathbenefit": [
            {
                "faceamount": 850000,
                "additionalprotection": 150000,
                "from": "1",
                "through": "10"
            },
            {
                "faceamount": 100000,
                "additionalprotection": 0,
                "from": "11",
                "through": "M"
            }
        ],
        "deathbenefitchangeyear": "11",
        "deathbenefitoption": "A_Level",
        "premium": [
            {
                "type": "Guideline_Level_Premium",
                "from": "1",
                "through": "10"
            }
        ],
        "premiummode": "Annual",
        "distributionmode": "Annual",
        "distribution": [
            {
                "type": "Specify_Amount",
                "amount": 0,
                "adjustment": "0",
                "from": "15",
                "through": "15"
            },
            {
                "type": "Solve_for_Income",
                "from": "A65",
                "through": "A90"
            }
        ],
        "balancesheetbenefit": "Yes",
        "balancesheetbenefitpercentage": 100,
        "interestrates": [
            {
                "allocations": [
                    {
                        "allocationname": "101",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    },
                    {
                        "allocationname": "131",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    },
                    {
                        "allocationname": "130",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    },
                    {
                        "allocationname": "129",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    }
                ],
                "from": "1",
                "through": "M"
            }
        ],
        "loanassumptions": {
            "discountcashvaluelowpoint": 0.85,
            "bankdiscountfirstyear": 0.9,
            "assumptions": [
                0.055,
                0.053,
                0.055,
                0.0571,
                0.0591,
                0.0607,
                0.062,
                0.0629,
                0.0636,
                0.0642,
                0.0646,
                0.0648,
                0.0651,
                0.0652,
                0.0653,
                0.045
            ]
        }
    }
};

export const IUL7Pay = {
    "id": "8ca33bfd-8192-41c6-a62c-7c964e58cc99",
    "webhook": "https://api.myilia.com/estimation/web-hook/39dd13e9-2750-4baf-a07b-db7f8cda3123",
    "run": {
        "estimatortype": "IUL",
        "iulsolvefor": "Death_Benefit",
        "stress": false,
        "illustration": true,
        "comparison": false,
        "reports": false,
        "deathbenefitonly": false,
        "express": false
    },
    "common": {
        "premiumterm": 7,
        "contributionterm": 7,
        "monthlypayclientextra": 0.05,
        "paymentfrequency": "Annual",
        "productcode": "941",
        "fullname": "Yogesh Patel",
        "verbose": false,
        "agent": {
            "fullname": "Ben Grams",
            "phoneareacode": "800",
            "phonedialnumber": "2949940",
            "addressline1": "5830 Granite Pkwy",
            "addressline2": "Suite 700",
            "addresscity": "Plano",
            "addressstate": "TX",
            "zip": "75024"
        },
        "incomeagefrom": 65,
        "incomeageto": 90,
        "trustfee": 1350,
        "pensionunderwriting": "Multi-Life",
        "issueage": "50",
        "premium": 13980,
        "gender": "Male",
        "rateclass": "Standard_NT",
        "dateofbirth": "02/11/1977",
        "funddateilia": "07/13/2022",
        "tranchenumber": "47",
        "carrier": "ALZ",
        "blendpercentage": [
            {
                "agefrom": 10,
                "ageto": 29,
                "blend": 0
            },
            {
                "agefrom": 30,
                "ageto": 39,
                "blend": 0.3
            },
            {
                "agefrom": 40,
                "ageto": 49,
                "blend": 0.35
            },
            {
                "agefrom": 50,
                "ageto": 54,
                "blend": 0.4
            },
            {
                "agefrom": 55,
                "ageto": 100,
                "blend": 0.5
            }
        ],
        "illustrationissuestate": "NV",
        "contributionamount": 50000,
        "totaldeathbenefit": "200000",
        "distributionloanrate": 6.15,
        "reportsalessummaryage": 90,
        "reportlowpointduration": 18,
        "growthrate": 0.0665,
        "incometaxrate": 0.37,
        "capitalgainstaxrate": 0.2,
        "statetaxrate": 0.055,
        "afrrate": 0.0454,
        "managementfee": 0.005,
        "arrangementfee": 500,
        "contributionamountemployer": 0,
        "paymentfrequencyemployer": "Annual"
    },
    "illustration": {
        "mecavoidance": "Adjust_Premiums",
        "deathbenefittype": "Specify_Amount",
        "deathbenefit": [
            {
                "faceamount": 850000,
                "additionalprotection": 150000,
                "from": "1",
                "through": "10"
            },
            {
                "faceamount": 100000,
                "additionalprotection": 0,
                "from": "11",
                "through": "M"
            }
        ],
        "deathbenefitchangeyear": "8",
        "deathbenefitoption": "B_Increasing",
        "premium": [
            {
                "type": "Guideline_Level_Premium",
                "from": "1",
                "through": "10"
            }
        ],
        "premiummode": "Annual",
        "distributionmode": "Annual",
        "distribution": [
            {
                "type": "Specify_Amount",
                "amount": 0,
                "adjustment": "0",
                "from": "15",
                "through": "15"
            },
            {
                "type": "Solve_for_Income",
                "from": "A65",
                "through": "A90"
            }
        ],
        "balancesheetbenefit": "Yes",
        "balancesheetbenefitpercentage": 100,
        "interestrates": [
            {
                "allocations": [
                    {
                        "allocationname": "101",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    },
                    {
                        "allocationname": "131",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    },
                    {
                        "allocationname": "130",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    },
                    {
                        "allocationname": "129",
                        "allocationrate": 6.65,
                        "allocationweight": 25
                    }
                ],
                "from": "1",
                "through": "M"
            }
        ],
        "loanassumptions": {
            "discountcashvaluelowpoint": 0.85,
            "bankdiscountfirstyear": 0.9,
            "assumptions": [
                0.055,
                0.053,
                0.055,
                0.0571,
                0.0591,
                0.0607,
                0.062,
                0.0629,
                0.0636,
                0.0642,
                0.0646,
                0.0648,
                0.0651,
                0.0652,
                0.0653,
                0.045
            ]
        }
    }
};